var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoottabletreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 36,
    viewBox: "0 0 19 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1v19",
    stroke: "#DFE2E3",
    strokeMiterlimit: 16,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 24l4.5 3.739v4.807C14 33.35 13.328 34 12.5 34h-6c-.828 0-1.5-.65-1.5-1.454V27.74L9.5 24zM7 28.63v3.432h5V28.63l-2.5-2.077L7 28.63z",
    fill: "#316DAA"
  })));
}
export default SvgRoottabletreact;